import React, { useEffect, useRef, useState } from 'react'

import kishLogo from '../../../../src/assets/images/fz-logo-anzali.svg'
import arvandLogo from '../../../../src/assets/images/fz-logo-arvand.svg'
import anzaliLogo from '../../../../src/assets/images/fz-logo-anzali.svg'
import arasLogo from '../../../../src/assets/images/fz-logo-aras.svg'
import chabaharLogo from '../../../../src/assets/images/fz-logo-chabahar.svg'
import ghesmLogo from '../../../../src/assets/images/fz-logo-gheshm.svg'
import arrowImage from '../../../../src/assets/images/ic_caret_down.svg'
import makooLogo from '../../../..//src/assets/images/fz-logo-makoo.svg'
import incheborunLogo from '../../../..//src/assets/images/fz-logo-incheborun.svg'
import mazandaranLogo from '../../../..//src/assets/images/fz-logo-mazandaran.svg'

import '../../Plate/plate.css'
import FDMBottomSheetSelectInput from './FDMBottomSheetSelectInput'
import { useForm } from 'react-hook-form'

import { useDispatch, useSelector } from 'react-redux'
import { IApplicationState } from 'Store/types'

import { useTranslation } from 'react-i18next'

type PersianMap = {
  [key: string]: string
}

interface PaletInputFreeZoneType {
  value: any
  onChange: (val: any) => void
  mode?: boolean
}

const PaletInputFreeZone: React.FC<PaletInputFreeZoneType> = ({ onChange, mode, value }) => {
  const { t } = useTranslation()
  const [englishNumber, setEnglishNumber] = useState('')
  const [persianNumber, setPersianNumber] = useState('')
  const { control } = useForm({})
  const [open, setOpen] = useState<boolean>(false)
  const [serialPlateOptions, setSerialPlateOptions] = useState<any[]>([])

  const [serialPlate, setSerialPlate] = useState<{
    value: string
    label: string
    id: number | null
  }>({
    value: '',
    label: '',
    id: null,
  })

  const [selectedZone, setSelectedZone] = useState<{
    value: string
    label: string
    logo: string
  }>({ value: t('ARVAND'), label: t('ARVAND'), logo: arvandLogo })

  const newVisit = useSelector((store: IApplicationState) => store.visits.newVisit)

  const { queryParams } = useSelector((store: IApplicationState) => store.visits.visitList)

  const { data: freeZoneList } = useSelector(
    (rootState: IApplicationState) => rootState.visits.freeZone,
  )

  const vehicleTypeIdRef = useRef<any>(null)

  useEffect(() => {
    if (selectedZone && freeZoneList?.length > 0) {
      const result = freeZoneList.filter(item => {
        return item.plateRegion.includes(selectedZone.value)
      })

      if (result.length > 0) {
        const options = result.map((a: any) => ({
          value: a.serial,
          label: a.serial,
          id: a.id,
        }))

        setSerialPlateOptions(options)
      } else {
        setSerialPlateOptions([])
      }
    }
  }, [selectedZone, freeZoneList])

  const toPersianNumerals = (str: string): string => {
    const persian: PersianMap = {
      '0': '۰',
      '1': '۱',
      '2': '۲',
      '3': '۳',
      '4': '۴',
      '5': '۵',
      '6': '۶',
      '7': '۷',
      '8': '۸',
      '9': '۹',
    }
    return str.replace(/[0-9]/g, (match: string) => persian[match])
  }

  const toEnglishNumerals = (str: string): string => {
    const english: PersianMap = {
      '۰': '0',
      '۱': '1',
      '۲': '2',
      '۳': '3',
      '۴': '4',
      '۵': '5',
      '۶': '6',
      '۷': '7',
      '۸': '8',
      '۹': '9',
    }
    return str.replace(/[\u06F0-\u06F9]/g, (match: string) => english[match])
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = toEnglishNumerals(e.target.value)
    const numericValue = value.replace(/[^0-9]/g, '')
    setEnglishNumber(numericValue || '')
    setPersianNumber(toPersianNumerals(numericValue))
  }

  useEffect(() => {
    if (typeof onChange === 'function') {
      onChange({
        type: 'FREEZONE',
        serialPlate,
        englishNumber,
        persianNumber,
        selectedZone,
      })
    }
  }, [serialPlate, englishNumber, persianNumber, selectedZone])

  useEffect(() => {
    if (newVisit?.carInfo?.plate) {
      setSerialPlate({
        label: newVisit.carInfo.plate.serialPlate?.label || '',
        value: newVisit.carInfo.plate.serialPlate?.value || '',
        id: newVisit.carInfo.plate.serialPlate?.id || null,
      })
      setEnglishNumber(newVisit.carInfo.plate.englishNumber || '')
      setPersianNumber(newVisit.carInfo.plate.persianNumber || '')
    }
  }, [newVisit])

  useEffect(() => {
    if (value && freeZoneList?.length > 0) {
      const foundZone = freeZoneList.find(item => item.serial == value?.cityCode && item.isFreeZone)

      if (foundZone) {
        const zoneOption = [
          { value: t('ARVAND'), label: t('ARVAND'), logo: arvandLogo },
          { value: t('KISH'), label: t('KISH'), logo: kishLogo },
          { value: t('ANZALI'), label: t('ANZALI'), logo: anzaliLogo },
          { value: t('ARAS'), label: t('ARAS'), logo: arasLogo },
          { value: t('CHABAHAR'), label: t('CHABAHAR'), logo: chabaharLogo },
          { value: t('GHESHM'), label: t('GHESHM'), logo: ghesmLogo },
          { value: t('MAZANDARAN'), label: t('MAZANDARAN'), logo: mazandaranLogo },
          { value: t('INCHEBORUN'), label: t('INCHEBORUN'), logo: incheborunLogo },
        ].find(z => z.value === foundZone.plateRegion)

        if (zoneOption) {
          setSelectedZone(zoneOption)
        }

        setSerialPlate({
          label: foundZone.serial,
          value: foundZone.serial,
          id: foundZone.id,
        })

        setEnglishNumber(value?.motorCycleOtherNumber || '')
        setPersianNumber(toPersianNumerals(value?.motorCycleOtherNumber || ''))
      }
    }
  }, [value, freeZoneList])

  useEffect(() => {
    if (mode) {
      setSerialPlate({ label: '', value: '', id: null })
      setEnglishNumber('')
      setPersianNumber('')
      setSerialPlateOptions([])
      if (queryParams?.plate) {
        setSerialPlate(queryParams.plate.serialPlate || { label: '', value: '', id: null })
        setSelectedZone({
          label: queryParams?.plate?.selectedZone?.label || '',
          value: queryParams?.plate?.selectedZone?.value || '',
          logo: queryParams?.plate?.selectedZone?.logo || '',
        })
        setEnglishNumber(queryParams.plate.englishNumber || '')
        setPersianNumber(queryParams.plate.persianNumber || '')
      }
    }
  }, [mode, queryParams])

  return (
    <div className="group">
      <div className="iran-vehicle-number-plate free-zone mx-auto group-[.validation-error]:bg-error !max-w-[300px]">
        <div className="number-plate max-with-plate">
          <FDMBottomSheetSelectInput
            style={{ fontFeatureSettings: "'lnum'" }}
            id="serialPlates"
            name="serialPlate"
            control={control}
            options={serialPlateOptions}
            value={serialPlate}
            label={t('ZONE')}
            onChange={(val: any) => setSerialPlate(val)}
            open={open}
            closeOnSelect={false}
            disabled={value?.isDisabled}
          />

          <input
            type="text"
            className="form-text"
            maxLength={2}
            value={serialPlate.label || value?.cityCode}
            readOnly
            disabled={value?.isDisabled}
          />
        </div>

        <div className="number-plate">
          <input
            type="text"
            className="form-text"
            maxLength={5}
            tabIndex={1}
            value={englishNumber}
            onChange={handleInputChange}
            lang="en"
            style={{ fontFeatureSettings: "'lnum'" }}
            dir="ltr"
            inputMode="numeric"
            disabled={value?.isDisabled}
          />
          <input
            type="text"
            className="form-text"
            maxLength={5}
            tabIndex={2}
            value={persianNumber}
            readOnly
            disabled={value?.isDisabled}
          />
        </div>

        <div className="" ref={vehicleTypeIdRef}>
          <FDMBottomSheetSelectInput
            contentCalssName="opacity-0 -z-10  bottom-0 left-0 absloute-important"
            id="freezone"
            disabled={value?.isDisabled}
            label={t('FREE_ZONE_TYPE')}
            name="freezone"
            control={control}
            value={selectedZone}
            options={[
              { value: t('ARVAND'), label: t('ARVAND'), logo: arvandLogo },
              { value: t('KISH'), label: t('KISH'), logo: kishLogo },
              { value: t('ANZALI'), label: t('ANZALI'), logo: anzaliLogo },
              { value: t('ARAS'), label: t('ARAS'), logo: arasLogo },
              {
                value: t('CHABAHAR'),
                label: t('CHABAHAR'),
                logo: chabaharLogo,
              },
              { value: t('GHESHM'), label: t('GHESHM'), logo: ghesmLogo },
              { value: t('MAKOO'), label: t('MAKOO'), logo: makooLogo },
              { value: t('MAZANDARAN'), label: t('MAZANDARAN'), logo: mazandaranLogo },
              { value: t('INCHEBORUN'), label: t('INCHEBORUN'), logo: incheborunLogo },
            ]}
            onChange={(val: any) => {
              setSelectedZone(val)
              setSerialPlate({ label: '', value: '', id: null })
            }}
            open={open}
            closeOnSelect={false}
          />
        </div>

        <div
          className="plate-flag"
          onClick={() => {
            setOpen(true)
            vehicleTypeIdRef?.current?.children[0].children[0].focus()
          }}
        >
          <div className="flex items-center flex-col gap-1 translate-x-1/2 absolute bottom-0 ">
            <div className="flex gap-1 items-center">
              <img src={selectedZone.logo} alt="لوگو منطقه آزاد" style={{ marginLeft: '-10px' }} />

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <img
                  src={arrowImage}
                  style={{
                    objectFit: 'contain',
                  }}
                />
              </div>
            </div>

            <span className="plate-flag-text text-white" style={{ marginLeft: '27px' }}>
              {selectedZone.label}
            </span>
          </div>
        </div>
      </div>
      <span
        style={{ color: 'rgb(216 75 75 )' }}
        className={`text-sm pr-5 flex pt-2 ${selectedZone.label !== '' && 'hidden'}`}
      >
        {t('SELECTED_LOGO')}{' '}
      </span>
    </div>
  )
}

export default PaletInputFreeZone
